<section class="page-wrap animated fadeIn">
  <div class="container">
    <h1 class="section-title"><span>Delivery Areas</span></h1>
    <div class="text-blurb">
      <h5 class="sub-title">Tired of the hassle of grocery store trips and not knowing where your food comes from?</h5>
      <p>At Willow Haven Farm, we solve that problem by delivering fresh, organic, and locally grown food directly to
        your doorstep. Whether you're short on time or just want to avoid the confusion of grocery labels, our delivery
        service brings healthy, trustworthy ingredients right to you. Check below to see if we deliver to your area and
        make healthy eating easier than ever. If you're within our delivery range, start shopping today and enjoy the
        convenience of having farm-fresh food delivered straight to your door.</p>
    </div>
    <div class="row">
      <div class="col-xl-5 col-lg-5 col-md-6 d-none d-sm-block">
        <div class="bg-image-wrap d-flex justify-content-start p-5"
          style="background-image: url('assets/images/landing/delivery-area/delivery.webp')" alt="delivery Areas">
        </div>
      </div>
      <div class="col-xl-7 col-lg-7 col-md-6">
        <div class="d-flex flex-column bg-white p-3 bg-opacity-50 rounded-1 align-items-start justify-content-center">
          <h2 class="text-center text-md-start h2-semibold">Where We Deliver:</h2>
          <ul class="ul-location-tag">
            <li *ngFor="let location of locations">
              {{location.name}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr class="my-5">
    <div class="row">
      <iframe src="https://www.google.com/maps/d/embed?mid=17rvdLZ_5AYsPnC86FJF1tKqVNA3KuqU&ehbc=2E312F" width="640"
        height="480" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  </div>
</section>